module.exports = __webpack_public_path__ + "media/fonts/Roboto/Roboto-Light-d592a653abb7a57fedd8d263f6f187c0.eot";